import React from "react";
import { Drawer, Table, Tag, Empty } from "antd";
import dayjs from "dayjs";
import { RawMaterial } from "../../../Types";
import { DRAWER_DETAIL_WIDTH, drawerTitle } from "../../../components";

interface Props {
  open: boolean;
  material: RawMaterial | null;
  onClose: () => void;
}

export const StockHistoryDrawer: React.FC<Props> = ({
  open,
  material,
  onClose,
}) => (
  <Drawer
    title={drawerTitle("Stock History", material?.name || "")}
    width={DRAWER_DETAIL_WIDTH}
    onClose={onClose}
    open={open}
  >
    <Table
      dataSource={material?.stock_history || []}
      columns={[
        {
          title: "Date",
          dataIndex: "created_at",
          key: "created_at",
          render: (v) => (
            <span className="text-xs text-gray-500">
              {dayjs(v).format("YYYY-MM-DD HH:mm")}
            </span>
          ),
        },
        {
          title: "Action",
          dataIndex: "action_type",
          key: "action_type",
          render: (v) => <Tag className="text-[11px] uppercase">{v}</Tag>,
        },
        {
          title: "Batch",
          dataIndex: "batch_no",
          key: "batch_no",
          render: (v) => (
            <span className="text-xs font-medium text-gray-700">{v}</span>
          ),
        },
        {
          title: "Change",
          key: "adjustment",
          render: (_: any, rec: any) => {
            const adj = rec.adjusted_quantity;
            const color =
              adj > 0
                ? "text-green-600"
                : adj < 0
                  ? "text-red-500"
                  : "text-gray-500";
            return (
              <span className={`text-xs font-semibold ${color}`}>
                {adj > 0 ? `+${adj}` : adj}
              </span>
            );
          },
        },
        {
          title: "Stock",
          key: "ledger",
          render: (_: any, rec: any) => (
            <div className="flex flex-col text-[11px] text-gray-400">
              <span>From: {rec.old_quantity}</span>
              <span className="text-gray-700 font-medium">
                To: {rec.new_quantity}
              </span>
            </div>
          ),
        },
        {
          title: "Notes",
          key: "details",
          render: (_: any, rec: any) => (
            <div className="flex flex-col text-[11px]">
              <span className="text-gray-500">{rec.note}</span>
              {rec.changed_by_username && (
                <span className="text-gray-400 mt-0.5">
                  By {rec.changed_by_username}
                </span>
              )}
            </div>
          ),
        },
      ]}
      rowKey="id"
      pagination={{ pageSize: 10, size: "small" }}
      size="small"
      locale={{
        emptyText: (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No stock movement recorded yet."
          />
        ),
      }}
    />
  </Drawer>
);
